__turbopack_context__.v({
  "banner": "index-module__ZiGhkW__banner",
  "default": "index-module__ZiGhkW__default",
  "error": "index-module__ZiGhkW__error",
  "warning": "index-module__ZiGhkW__warning",
});
